import { render, staticRenderFns } from "./open-api.vue?vue&type=template&id=2d2df912&"
import script from "./open-api.vue?vue&type=script&lang=js&"
export * from "./open-api.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports